// available language for the platform
export const LANGUAGES = [
  { code: 'de', countryCode: 'AT' },
  { code: 'en', countryCode: 'GB' },
];